import {
  getAtsMustNotBeInPastError,
  getEtcDateOrderError,
  notificationSchema,
} from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";
import i18n from "i18next";
import { z } from "zod";

const createAtsSchema = () =>
  z.object({
    ats: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;

        if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
          const parsed = new Date(value);
          return Number.isNaN(parsed.getTime()) ? value : parsed;
        }

        return value;
      },
      z.date({
        required_error: i18n.t("form-validation.mandatory", { label: "ATS" }),
        invalid_type_error: i18n.t("form-validation.invalid-date", { label: "ATS" }),
      }),
    ),
  });

const createEtsSchema = () =>
  z.object({
    ets: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;

        if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
          const parsed = new Date(value);
          return Number.isNaN(parsed.getTime()) ? value : parsed;
        }

        return value;
      },
      z
        .date({
          invalid_type_error: i18n.t("form-validation.invalid-date", { label: "ETS" }),
        })
        .optional(),
    ),
  });

const createEtcSchema = () =>
  z.object({
    etc: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;

        if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
          const parsed = new Date(value);
          return Number.isNaN(parsed.getTime()) ? value : parsed;
        }

        return value;
      },
      z.date({
        required_error: i18n.t("form-validation.mandatory", { label: "ETC" }),
        invalid_type_error: i18n.t("form-validation.invalid-date", { label: "ETC" }),
      }),
    ),
  });

export const startSlopsDisposalSchema = () =>
  createAtsSchema()
    .merge(createEtsSchema())
    .merge(createEtcSchema())
    .merge(notificationSchema)
    .superRefine((value, ctx) => {
      const atsError = getAtsMustNotBeInPastError(value.ats);

      if (atsError) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["ats"],
          message: atsError,
        });
      }

      const error = getEtcDateOrderError({ etc: value.etc, ets: value.ets, ats: value.ats });

      if (!error) {
        return;
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["etc"],
        message: error,
      });
    });

export type StartSlopsDisposalSchema = z.infer<ReturnType<typeof startSlopsDisposalSchema>>;
